export const authenticatedRequest = (url, options) => {
  return fetch(url, { ...options }).then(async (response) => {
    if (!response.ok) {
      throw new Error('Det oppstod dessverre en feil')
    }

    return await response.json()
  })
}
